/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Grid } from 'antd';

import ROUTES from '@constants/routes';
import logoImage from '@assets/images/logo.svg';
import logoImageMobile from '@assets/images/logoMobile.svg';

import Link from '../Link';

const HeaderLogo = (props) => {
  const breakPoints = Grid.useBreakpoint();

  return (
    <Link to={ROUTES.DASHBOARD}>
      <img alt="Logo" src={breakPoints.lg ? logoImage : logoImageMobile} {...props} />
    </Link>
  );
};

export default HeaderLogo;
